import {Injectable} from '@angular/core';
import {CanActivate, Router, UrlTree} from '@angular/router';
import {Observable, of} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {ToastrService} from 'ngx-toastr';

import {ApiService} from './api.service';
import {AuthService} from './auth.service';
import {RoleService} from './role.service';

@Injectable({
  providedIn: 'root'
})
export class SubscriptionAccessGuardService implements CanActivate {
  private readonly disabledMessage = 'Subscriptions are disabled for your organization. Please contact your administrator.';

  constructor(
    private auth: AuthService,
    private apiService: ApiService,
    private roleService: RoleService,
    private router: Router,
    private toastr: ToastrService,
  ) {}

  canActivate(): Observable<boolean | UrlTree> | boolean | UrlTree {
    const userInfo = this.auth.getCurrentUserInfo();
    const groups = userInfo?.role;

      if (this.auth.isSuperUser() || this.roleService.isSalesManager(groups)) {
      return true;
    }

    if (!this.roleService.canAccessSubscriptions(groups)) {
      return this.router.createUrlTree([this.roleService.getDefaultRoute(groups)]);
    }

    return this.apiService.getAlertDirections().pipe(
      map((response: any) => {
        if (response?.subscription_enabled !== false) {
          return true;
        }
        this.toastr.error(this.disabledMessage, 'Access Disabled');
        return this.router.createUrlTree([this.roleService.getDefaultRoute(groups)]);
      }),
      catchError(() => {
        return of(this.router.createUrlTree([this.roleService.getDefaultRoute(groups)]));
      })
    );
  }
}
